import { render, staticRenderFns } from "./LoyaltySettingExclusionsCustomer.vue?vue&type=template&id=3f202b9e&scoped=true&"
import script from "./LoyaltySettingExclusionsCustomer.vue?vue&type=script&lang=js&"
export * from "./LoyaltySettingExclusionsCustomer.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltySettingExclusionsCustomer.vue?vue&type=style&index=0&id=3f202b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f202b9e",
  null
  
)

export default component.exports